Optional overrides that take precedence over the draft when posting or updating a position profile from a draft.
